import { useNavigate } from '@tanstack/react-router'
import { useAtom } from 'jotai'
import { useState } from 'react'

import { useLogout, useResendIdentityVerificationEmail } from '@/gen/publicApi'

import { Button } from '@/components/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/dialog'
import { useToast } from '@/components/toast/useToast'

import { authTokenAtom } from '@/state/authToken'
import { useIdentity } from '@/state/identity'

export default function RequiresEmailVerification() {
    const [resentVerifcationEmail, setResentVerifcationEmail] = useState(false)
    const { identity, fetched } = useIdentity()
    const { toast } = useToast()
    const [, setAuthToken] = useAtom(authTokenAtom)
    const navigate = useNavigate()
    const resendVerificationEmailMutation = useResendIdentityVerificationEmail({
        mutation: {
            onSuccess: () => {
                setResentVerifcationEmail(true)
            },
            onError: error => {
                console.error('Error resending verification email', error)
                toast({
                    variant: 'destructive',
                    title: 'Verification email resend failed!',
                    description: 'Resending verification email failed, please try again',
                })
            },
        },
    })

    const logoutMutation = useLogout({
        mutation: {
            onSettled: () => {
                setTimeout(() => {
                    navigate({
                        to: '/login',
                    })
                    setAuthToken(undefined), 1
                })
            },
        },
    })

    if (!fetched || !identity?.requiresEmailVerification) {
        return null
    }

    return (
        <Dialog open={true}>
            <DialogContent overlayClassName="backdrop-blur">
                <DialogHeader>
                    <DialogTitle>Please verify your email address</DialogTitle>
                </DialogHeader>
                {!resentVerifcationEmail ? (
                    <>
                        <p>Pleas check your inbox and click the link in the verification email to complete signup.</p>
                        <p>
                            If you have not received the email, you can resend a new one below. If you still have not
                            received it, check your spam folder.
                        </p>
                    </>
                ) : (
                    <>
                        <p>
                            We've sent you a new verification email. Check your inbox and click the link in the
                            verification email to complete signup.
                        </p>
                        <p>If you have not received the email within a few minutes, please check your spam folder.</p>
                    </>
                )}
                <DialogFooter>
                    <Button
                        type="button"
                        onClick={() => {
                            // @ts-expect-error - kubb codegen
                            resendVerificationEmailMutation.mutate()
                        }}
                        disabled={resendVerificationEmailMutation.isPending}
                    >
                        Resend email
                    </Button>
                    <Button
                        type="button"
                        variant="destructive"
                        onClick={() => {
                            // @ts-expect-error - kubb codegen
                            logoutMutation.mutate()
                        }}
                        disabled={resendVerificationEmailMutation.isPending}
                    >
                        Logout
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
